module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-team-single",
    class: ['c-team-single--' + _vm.position, 'js-team-single-' + _vm.position, _vm.isShown ? 'is-shown' : '', _vm.imageLoading ? 'is-loading' : '']
  }, [_c('div', {
    ref: "image",
    staticClass: "c-team-single__image-container u-relative u-inline-block u-overflow-h"
  }, [_c('div', {
    staticClass: "c-team-single__image-container__placeholder o-box--1by1 u-relative u-overflow-h"
  }, [_c('div', {
    staticClass: "c-team-single__image-container__image u-absolute u-pos-tl u-fit u-grayscale",
    class: ['c-team-single__image-container__image--' + _vm.getImageSlugFromName()],
    style: ({
      'background-image': 'url(' + _vm.member.image + ')'
    })
  }), _vm._v(" "), _c('img', {
    staticClass: "u-absolute u-hide u-opacity--0 u-overflow-h",
    attrs: {
      "src": _vm.member.image,
      "alt": "",
      "title": _vm.member.firstname + ' ' + _vm.member.lastname,
      "width": "1px",
      "height": "1px"
    },
    on: {
      "load": function($event) {
        _vm._onLoad()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-team-single__image-container__loader u-absolute u-pos-tl u-zindex--2 u-fit u-bg--black-near"
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-relative u-marg-t-xs"
  }, [_c('div', {
    staticClass: "c-team-single__name t-fsize--lg t-fweight--semi-bold u-color--white"
  }, [_vm._v(_vm._s(_vm.member.firstname) + " " + _vm._s(_vm.member.lastname))]), _vm._v(" "), _c('div', {
    staticClass: "c-team-single__job u-marg-t-xxs t-fsize--xxs t-fweight--semi-bold u-color--white u-uppercase u-opacity--50"
  }, [_vm._v("/ "), _c('span', [_vm._v(_vm._s(_vm.member.job))])]), _vm._v(" "), _c('div', {
    staticClass: "c-team-single__summary o-content is-white u-marg-t-sm u-lheight--150p u-color--white",
    domProps: {
      "innerHTML": _vm._s(_vm.member.summary)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-team-single__social-container u-marg-t-xs"
  }, [(_vm.member.twitter) ? _c('a', {
    staticClass: "c-team-single__social-link u-relative u-inline-block t-ffamily--simplon t-fweight--bold t-fsize--xs u-uppercase u-color--white u-cursor-pointer",
    class: [_vm.$root.isTouch ? 'is-touch' : ''],
    attrs: {
      "href": _vm.member.twitter,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "u-relative u-table u-fit"
  }, [_c('div', {
    staticClass: "u-table-cell u-valign-middle u-align-center"
  }, [_c('app-icon', {
    staticClass: "u-fill--white",
    attrs: {
      "name": "icon-social--twitter",
      "width": "14px"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.member.linkedin) ? _c('a', {
    staticClass: "c-team-single__social-link u-relative u-inline-block t-ffamily--simplon t-fweight--bold t-fsize--xs u-uppercase u-color--white u-cursor-pointer",
    class: [_vm.$root.isTouch ? 'is-touch' : ''],
    attrs: {
      "href": _vm.member.linkedin,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "u-relative u-table u-fit"
  }, [_c('div', {
    staticClass: "u-table-cell u-valign-middle u-align-center"
  }, [_c('app-icon', {
    staticClass: "u-fill--white",
    attrs: {
      "name": "icon-social--linkedin",
      "width": "14px"
    }
  })], 1)])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48c681c6"}!./src/scripts/components/app-team-single/template.html
// module id = 465
// module chunks = 0